import { Link } from "react-router-dom";
import PageBanner from "../../component/PageBanner";
import React from "react";
import { FaBolt, FaBullseye, FaEye } from "react-icons/fa";
import SocialMediaSidebar from "../SocialMediaSidebar";
import SectionHeader from "../SectionHeader";
import vision from "../../assets/images-webp/vision.webp";
import mission from "../../assets/images-webp/mission.webp";
import ScrollToTopButton from "../ScrollToTopButton";
import SectionHeaderNoPDF from "../SectionHeaderNoPDF";

const VisionMission = () => {
  return (
    <>
      <div>
        <SocialMediaSidebar />
      </div>
      <PageBanner
        title="Vision & Mission"
        breadcrumb={[
          { label: "Home", href: "/" },
          { label: "About Us" },
          { label: "Vision & Mission" },
        ]}
      />
      <div>
        <ScrollToTopButton />
      </div>

      <div className="max-w-6xl mx-auto p-4">
        <SectionHeaderNoPDF
          title="Vision & Mission @ AJEEVI"
          shareUrl="https://swachhajv.ajeevi.in/vision-mission"
        />
      </div>

      {/* Page content */}

      <div className="w-full px-4 sm:px-6 md:px-10 lg:px-28 py-10 bg-white text-center font-poppins ">
        {/* Heading */}
        <h3 className="text-xl sm:text-2xl font-semibold text-black mb-6">
          Empowering Clean Cities Through Smart Waste Management
        </h3>

        {/* Icons + Video */}
        <div className="flex flex-col md:flex-row items-center justify-center gap-10 mb-10">
          {/* Left Image */}
          <div className="w-28 h-28 sm:w-32 sm:h-32 md:w-40 md:h-40">
            <img
              src={vision} // replace with actual import or path
              alt="Vision Icon"
              className="w-full h-full object-contain"
            />
          </div>

          {/* Embedded YouTube Video */}
          <div className="aspect-video w-full max-w-md text-center">
            <iframe
              className="w-full h-full shadow-lg"
              src="https://www.youtube.com/embed/fdOfcUI_sWk?si=5S_MpFCK9d8Nxd6w"
              title="Ajeevi Technologies Pvt. Ltd."
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>

          {/* Right Image */}
          <div className="w-28 h-28 sm:w-32 sm:h-32 md:w-40 md:h-40">
            <img
              src={mission} // replace with actual import or path
              alt="Mission Icon"
              className="w-full h-full object-contain"
            />
          </div>
        </div>

        {/* Description */}
        <p className="text-black text-base sm:text-lg max-w-4xl mx-auto mb-10 px-2 ">
          We are working with a vision of Building Sustainable Future. We aspire
          to design and provide solutions that are sustainable and can provide a
          better quality of life for generations to come. Our mission is to be a
          pioneer in IoT technologies, primarily in the domains of Waste
          Management & Transport. We strive to provide different
          technology-based solutions in waste management and transport domains
          to cater to varied requirements of city administrations.
        </p>

        {/* Vision & Mission Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-6xl mx-auto px-2 ">
          <div className="bg-white p-6 shadow-lg border rounded-lg">
            <div className="flex justify-center text-[#00D084] text-5xl sm:text-6xl mb-4">
              {/* <img src={vision} alt="Vision Icon" className="w-12 h-12 sm:w-16 sm:h-16 object-contain" /> */}
              <FaEye />
            </div>
            <h4 className="text-lg sm:text-xl font-semibold mb-2">Vision</h4>
            <p className="text-black text-base sm:text-lg">
              To create a sustainable and cleaner urban environment by
              leveraging smart technologies and data-driven systems, setting the
              benchmark for efficient waste management across India.
            </p>
          </div>

          <div className="bg-white p-6 shadow-lg border rounded-lg">
            <div className="flex justify-center text-[#00D084] text-5xl sm:text-6xl mb-4">
              <img
                src={mission}
                alt="Mission Icon"
                className="w-12 h-12 sm:w-16 sm:h-16 object-contain"
              />
            </div>
            <h4 className="text-lg sm:text-xl font-semibold mb-2">Mission</h4>
            <p className="text-black text-base sm:text-lg">
              To revolutionize the waste management ecosystem by introducing
              IoT, automation, and real-time data analytics, enabling
              municipalities to optimize operations, reduce costs, and enhance
              environmental outcomes.
            </p>
          </div>
        </div>
      </div>

      <div className="bg-white w-full px-4 sm:px-6 md:px-10 lg:px-28 py-10 text-[#1a1a1a] font-sans text-justify">
        {/* Title */}
        <h2 className="text-xl sm:text-2xl font-bold text-[#00D084] mb-4">
          The Future of Smart Waste Management
        </h2>

        {/* Intro Paragraph */}
        <p className="text-black text-base sm:text-lg mb-6">
          Rapid urbanisation and industrial growth have resulted in massive
          garbage output, posing significant challenges for effective waste
          management. Traditional methods often fall short, leading to
          environmental damage and increased costs. IoT-based Smart Waste
          Management Systems tackle these issues using sensors, data analytics,
          and automation. Real-time data enables dynamic routing, reduces fuel
          use, and improves source-level sorting. RFID and QR code technologies
          streamline asset tracking and enable automated alerts, centralised
          monitoring, route optimisation, and seamless integration with waste
          facilities.
        </p>

        {/* Key Processes */}
        <h3 className="text-lg sm:text-xl font-bold mb-2">
          Key Processes in IoT-based Waste Management:
        </h3>
        <ul className="list-disc pl-6 text-black text-base sm:text-lg space-y-2">
          <li>
            <strong>Asset Tagging and Registration:</strong> RFID tags and QR
            codes uniquely identify each waste bin, storing location, bin size,
            and schedule data.
          </li>
          <li>
            <strong>Data Encoding and Linking:</strong> Tags are linked to a
            central system, maintaining an accurate digital record of physical
            bins.
          </li>
          <li>
            <strong>Sensor Deployment:</strong> Sensors integrated with
            collection vehicles track fill levels, bin status, and location in
            real time.
          </li>
          <li>
            <strong>Centralized Monitoring and Analytics:</strong> Real-time
            dashboards allow tracking of bins, routes, and performance metrics.
          </li>
          <li>
            <strong>Automated Alerts:</strong> The system triggers notifications
            when bins are full or irregularities are detected.
          </li>
          <li>
            <strong>Route Optimization:</strong> Smart routing reduces fuel
            consumption and improves efficiency.
          </li>
          <li>
            <strong>Maintenance & QA:</strong> Alerts flag sensor faults, and
            regular checks ensure system health.
          </li>
          <li>
            <strong>Integration with Sorting Facilities:</strong> Helps improve
            recycling rates by ensuring correct segregation at source.
          </li>
        </ul>

        {/* Conclusion */}
        <h3 className="text-lg sm:text-xl font-bold mt-8 mb-2">Conclusion</h3>
        <p className="text-black text-base sm:text-lg mb-4">
          The widespread adoption of smart waste systems offers transformative
          improvements over traditional methods. Using IoT, AI, and data
          analytics, these solutions boost efficiency, enable predictive
          maintenance, support circular economy efforts, and reduce operational
          costs.
        </p>

        <h3 className="text-lg sm:text-xl font-bold mt-8 mb-2">
          Ajeevi's Contribution
        </h3>
        <p className="text-black text-base sm:text-lg mb-2">
          Ajeevi Technologies delivers tailored solutions in IoT,
          sustainability, and citizen engagement:
        </p>
        <ul className="list-disc pl-6 text-black text-base sm:text-lg space-y-2 mb-4">
          <li>
            <strong>IoT-enabled Solutions:</strong> Smart waste, smart parking,
            smart lighting, and smart water systems with remote monitoring
            capabilities.
          </li>
          <li>
            <strong>Sustainable Energy:</strong> Energy-efficient systems
            powered by renewable sources like solar and wind.
          </li>
          <li>
            <strong>Data Analytics:</strong> Real-time insights for performance
            improvement and decision-making.
          </li>
          <li>
            <strong>Citizen Engagement:</strong> Platforms for feedback,
            reporting issues, and public participation via apps and web portals.
          </li>
        </ul>
        <p className="text-black text-base sm:text-lg">
          Overall, Ajeevi's vision supports cleaner, smarter, and
          citizen-centric cities. Learn more at{" "}
          <a
            href="https://www.ajeevi.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#00D084] hover:text-[#00b075] transition"
          >
            www.ajeevi.com
          </a>
        </p>
      </div>
    </>
  );
};

export default VisionMission;
